import { create } from 'zustand'

interface CustomersSearchStore {
    searchQuery: string
    setSearchQuery: (query: string) => void
    clearSearch: () => void
    hasActiveSearch: () => boolean
}

export const useCustomersSearchStore = create<CustomersSearchStore>()((set, get) => ({
    searchQuery: '',
    setSearchQuery: query => set({ searchQuery: query }),
    clearSearch: () => set({ searchQuery: '' }),
    hasActiveSearch: () => get().searchQuery !== '',
}))

export const useCustomersSearchQuery = () => useCustomersSearchStore(state => state.searchQuery)
export const useSetCustomersSearchQuery = () =>
    useCustomersSearchStore(state => state.setSearchQuery)
export const useClearCustomersSearch = () => useCustomersSearchStore(state => state.clearSearch)
export const useHasActiveCustomersSearch = () =>
    useCustomersSearchStore(state => state.hasActiveSearch())
